module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v("В корзине:")]), _vm._v(" "), _c('p', [_vm._v("В "), _c('a', {
    attrs: {
      "href": "/shop/cart"
    }
  }, [_vm._v("корзине")]), _vm._v(" " + _vm._s(_vm.numeral(_vm.totalCount).format('0,0')) + " товаров\n      на сумму " + _vm._s(_vm.numeral(_vm.totalPrice).format('0.00 $')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v("Проверьте ваши данные:")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Имя: " + _vm._s(_vm.customer.last_name) + " " + _vm._s(_vm.customer.first_name) + " " + _vm._s(_vm.customer.middle_name))]), _vm._v(" "), _c('p', [_vm._v("Телефон: " + _vm._s(_vm.customer.phone))]), _vm._v(" "), _c('p', [_vm._v("E-mail: " + _vm._s(_vm.customer.email))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9d97848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/order/CheckStep.vue
// module id = 656
// module chunks = 2